"use strict";
/**
 * GST STATEMENT — the hospital's statutory GST working for one period (owner, 2026-10-27).
 *
 * "see income from OP receipts, IP billing and pharmacy. these three should show in GST based on their status — exempted, taxable — and only input is
 * allowed related to pharmacy purchase and tax payable is pharmacy billing."
 *
 * Every amount is integer PAISE. The statement is built from the SOURCE DOCUMENTS (invoices, settlements, pharmacy sale lines, goods receipts, return
 * entries), never from the general ledger: the ledger does not reverse GST on a return, so a statement read from it would overstate the tax payable. The
 * ledger is shown beside it as a tie-out (`tieOut`) with the reason for each difference.
 *
 * A WORKING, NOT A RETURN. It lays out what GSTR-3B (3.1(a), 3.1(c), 4(A)(5), 6.1) and GSTR-1 (B2CS, exempt, credit notes to unregistered, HSN) need,
 * so the accountant keys or uploads from one place. It files nothing.
 */
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=gst-statement.dto.js.map